import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
})
/**
 * Hero according to bulma is navigation bar with title and subtitle of the page
 */
export class HeroComponent implements OnInit {
  isMenuOpen;
  @Input() title: string;
  @Input() subtitle: string;

  constructor() {}

  ngOnInit() {
    this.isMenuOpen = false;
  }

  public showMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
}



// WEBPACK FOOTER //
// ./src/app/ui-general/components/hero/hero.component.ts